import * as TYPES from './_types';
import { apiService } from 'utils/api';
import { successHandler, errorHandler } from 'utils/helpers/alerts';

export const fetchChannelsStart = () => {
  return { type: TYPES.FETCH_CHANNELS };
};
export const fetchChannelsSuccess = channels => {
  return { type: TYPES.FETCH_CHANNELS_SUCCESS, payload: { channels: channels } };
};

export const fetchChannelsFail = error => {
  return { type: TYPES.FETCH_CHANNELS_FAILURE, payload: { channels: error } };
};

export const fetchChannels = () => {
  return dispatch => {
    dispatch(fetchChannelsStart());

    return apiService
      .get('/channels')
      .then(response => {
        const channels = response.data;
        dispatch(fetchChannelsSuccess(channels));

        return response.data;
      })
      .catch(error => {
        dispatch(fetchChannelsFail(error));
      });
  };
};

export const fetchActivitiesStart = params => {
  return { type: TYPES.FETCH_CHANNEL_ACTIVITY, payload: params };
};

export const fetchActivitiesSuccess = activities => {
  return { type: TYPES.FETCH_CHANNELS_ACTIVITY_SUCCESS, payload: activities };
};

export const fetchActivitiesFail = error => {
  return { type: TYPES.FETCH_CHANNELS_ACTIVITY_FAILURE, payload: { activities: error } };
};

export const fetchActivities = params => {
  return dispatch => {
    dispatch(fetchActivitiesStart(params));

    return apiService
      .get('/channels/activity', { params })
      .then(response => {
        const activities = response.data;
        dispatch(fetchActivitiesSuccess({ activities: activities, params }));
        return response.data;
      })
      .catch(error => {
        dispatch(fetchActivitiesFail(error));
      });
  };
};

export const fetchIntegrationsStart = params => {
  return { type: TYPES.FETCH_INTEGRATIONS, payload: params };
};

export const fetchIntegrationsSuccess = integrations => {
  return { type: TYPES.FETCH_INTEGRATIONS_SUCCESS, payload: integrations };
};

export const fetchIntegrationsFail = error => {
  return { type: TYPES.FETCH_INTEGRATIONS_FAIL, payload: { payload: error } };
};

export const fetchIntegrations = () => {
  return dispatch => {
    dispatch(fetchIntegrationsStart());

    return apiService
      .get('/directives/integrations')
      .then(response => {
        dispatch(fetchIntegrationsSuccess({ integrations: response.data }));
        return response.data;
      })
      .catch(error => {
        dispatch(fetchIntegrationsFail(error));
      });
  };
};

export const updateChannelEmail = params => {
  return dispatch => {
    dispatch({ type: TYPES.UPDATE_CHANNEL_EMAIL });
    return apiService
      .put('/channels/emails', params)
      .then(response => {
        dispatch({ type: TYPES.UPDATE_CHANNEL_EMAIL_SUCCESS, payload: params });
        successHandler(dispatch, 'Successfully updated!');
        return response.data;
      })
      .catch(error => {
        dispatch({ type: TYPES.UPDATE_CHANNEL_EMAIL_FAILURE });
        errorHandler(dispatch, error);
      });
  };
};

export const updateChannelDevice = params => {
  return dispatch => {
    dispatch({ type: TYPES.UPDATE_CHANNEL_DEVICE });
    return apiService
      .put('/channels/devices', params)
      .then(response => {
        dispatch({ type: TYPES.UPDATE_CHANNEL_DEVICE_SUCCESS, payload: params });
        successHandler(dispatch, 'Successfully updated!');
        return response.data;
      })
      .catch(error => {
        dispatch({ type: TYPES.UPDATE_CHANNEL_DEVICE_FAILURE });
        errorHandler(dispatch, error);
      });
  };
};

export function unTrustDevice(params) {
  return dispatch => {
    dispatch({
      type: TYPES.UNTRUST_DEVICE
    });

    return apiService
      .put(`devices/${params.id}/untrust`, params)
      .then(response => {
        dispatch({ type: TYPES.UNTRUST_DEVICE_SUCCESS, payload: response.data });
        successHandler(dispatch, 'Successfully untrusted!');
        return response.data;
      })
      .catch(error => {
        dispatch({ type: TYPES.UNTRUST_DEVICE_FAILURE });
      });
  };
}



// WEBPACK FOOTER //
// ./src/views/channels/_actions.js